import React from 'react'

import Container from './container'
import * as styles from './footer.module.css'

const Footer = () => (
  <Container as="footer">
    <div className={styles.container}>
      Built with ❤️ to give you the best Buyer Experience
    </div>
  </Container>
)

export default Footer
